import { ButtonLegacy } from '@/components/ui/button-legacy'
import { AlertTriangleIcon, XCloseIcon } from '@/components/ui/icons'
import { Modal } from '@/components/ui/modal'
import {
	ModalBody,
	ModalHeader,
	ModalParagraph,
	ModalTitle
} from '@/components/ui/modal-atoms'
import { Separator } from '@/components/ui/separator'
import { useTranslation } from '@/translations/i18n'

export const ManualRetouchingErrorModal = ({
	onClose
}: {
	onClose: () => void
}) => {
	const { t } = useTranslation()
	return (
		<Modal closeIconOffset='sm' onOverlayClick={onClose} width={480}>
			<ModalHeader>
				<ButtonLegacy
					onClick={onClose}
					shape='square'
					size='sm'
					type='button'
					variant='tertiary'
				>
					<XCloseIcon size={20} />
				</ButtonLegacy>
				<h3>{t('common:error')}</h3>
			</ModalHeader>

			<Separator orientation='horizontal' />

			<ModalBody className='items-center justify-center text-center text-neutral-900 [&_svg]:fill-danger-500'>
				<div className='flex flex-col items-center gap-2'>
					<AlertTriangleIcon size={40} />
					<ModalTitle>
						{t('photoset:ai_manual_retouching.error_modal_title')}
					</ModalTitle>
					<ModalParagraph>
						{t(
							'photoset:ai_manual_retouching.error_modal_paragraph'
						)}
					</ModalParagraph>
				</div>
			</ModalBody>

			<Separator orientation='horizontal' />

			<ModalBody className='py-[18px]'>
				<ButtonLegacy
					onClick={onClose}
					type='button'
					variant='tertiary'
				>
					{t('common:close')}
				</ButtonLegacy>
			</ModalBody>
		</Modal>
	)
}
